import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { DialogContentRoot } from './DialogContent.style';

const DialogContent = ({ children, ...rest }) => {
  const [hasScroll, setHasScroll] = useState(false);
  const refCallback = useCallback(element => {
    if (element) {
      setHasScroll(element.scrollHeight > element.clientHeight);
    }
  }, []);
  return (
    <DialogContentRoot
      ref={refCallback}
      data-qa-id="dialog-content"
      hasScroll={hasScroll}
      {...rest}>
      {children}
    </DialogContentRoot>
  );
};

DialogContent.propTypes = {
  children: PropTypes.node
};

export default DialogContent;
